const enDivergence = {
  divergence: {
    table: {
      loading: 'Loading requests...',
      noData: 'No request found',
      requestedByHint:
        'Host who travelled to the property and asked for the reimbursement. May not be the one who performed the service, if the appointment was reopened.',
      headers: {
        code: 'Code',
        type: 'Type',
        realty: 'Property',
        host: 'Host',
        realEstate: 'Customer',
        createdAt: 'Created at',
        status: 'Status',
        items: 'Items',
        estimated: 'Estimate',
      },
    },

    type: {
      AREA: 'Incorrect area',
      FURNITURE: 'Furniture',
      TROUSSEAU: 'Trousseau',
      DISPLACEMENT: 'Displacement',
      TRIP_REIMBURSEMENT: 'Reimbursement',
    },

    kind: {
      RECALCULATION: 'Recalculation',
      REIMBURSEMENT: 'Reimbursement',
    },

    status: {
      AWAITING_APPROVAL: 'Pending',
      AWAITING_PAYMENT: 'Awaiting payment',
      PAID: 'Paid',
      APPROVED: 'Recalculated',
      REFUSED: 'Refused',
      CONTESTED: 'Contested',
      REVERSED: 'Reversed',
    },

    filters: {
      status: 'Status',
      type: 'Type',
      kind: 'Kind',
    },

    queue: {
      pendingFor: 'Waiting for {hours}h',
      finished: 'No pending items',
    },

    actions: {
      review: 'Review',
      recalculate: 'Recalculate',
      refuse: 'Refuse',
      close: 'Close',
      reverse: 'Reverse',
      contest: 'Contest',
      back: 'Back',
      confirm: 'Confirm',
      approveReimbursement: 'Approve reimbursement',
    },

    review: {
      title: 'Recalculation request',
      reimbursementTitle: 'Reimbursement request',
      reimbursementItems: 'Trip reported by the host',
      appointment: 'Appointment',
      host: 'Host',
      realEstate: 'Customer',
      items: 'Reported divergences',
      registered: 'Current registry',
      declared: 'Reported by host',
      squareMeters: '{value} sqm',
      hasFeature: 'Present on site',
      notInRegistry: 'Not in the registry',
      checkIn: 'Host check-in',
      checkInMap: 'View on map',
      checkInFailed: 'Could not load the check-in',
      noCheckInLocation: 'No location recorded',
      distanceFromRealty: '{value} from the property',
      distanceHint: 'Straight-line distance between the host check-in and the property. For displacement, it is measured against the closest property in the appointment.',
      distanceFarHint: 'The check-in was far from the property. Worth checking the evidence before approving.',
      description: "Host's description",
      noDescription: 'No description',
      delta: 'Recalculation effect',
      hostDelta: 'Host receives',
      realEstateDelta: 'Customer pays',
      previousTotal: 'Current amount',
      newTotal: 'Recalculated amount',
      simulating: 'Calculating...',
      complementary:
        'The original payment cannot be reversed (already transferred, already invoiced, or the statement no longer matches the current calculation). The adjustment will be issued as a complementary payment for the difference only.',
      openAppointment: 'Open the appointment in a new tab',
      noHostShare:
        "This customer's contract has no host share configured for this item, so the host receives nothing from this adjustment. The customer charge is correct. If the host should be paid, fix the contract before approving.",
      evidence: 'Attached photos',
      noEvidence: 'No photo attached',
      openPhoto: 'Open the photo in a new tab',
      photoUnavailable: 'This photo could not be loaded',
      appliedDelta:
        'Amount already issued',
      nothingToDo:
        'This request is already resolved. Nothing to do here.',
      contestReason:
        'Contest reason',
      contestReasonHint:
        'At least 10 characters. It justifies the reversal in the statement.',
      reviewCommentLabel: 'Review note',
      contestReasonLabel:
        'Contest reason',
      confirmContest:
        'Register the contest? No amount changes now — the reversal is a separate step.',
      confirmReverse:
        'Confirm the reversal? The adjustment will be undone.',
      confirmReverseWithValues:
        'Confirm the reversal? The host returns {host} and the customer recovers {realEstate}.',
      reviewComment: 'Review note',
      reviewCommentHint:
        'On a refusal, this text goes to the host as the reason. On an approval, it stays internal.',
      selectItem: 'Include this divergence in the decision',
      selectAtLeastOne: 'Select at least one divergence to approve or refuse.',
      partialSelection: 'Unselected divergences stay pending and can be decided later, in a new review.',
      noPendingItems: 'This request has no items pending review.',
      confirmRecalculate:
        'Confirm the recalculation? The property registry will be corrected and the amounts reissued.',
      confirmRecalculateWithValues:
        'Confirm the recalculation? The property registry will be corrected, the host receives {host} and the customer pays {realEstate}.',
      confirmRefuse: 'Confirm the refusal? No amount will be changed.',
      notApplicable: 'Not applicable',
      canceledAt: 'Canceled at',
      cancelReason: 'Cancellation reason',
      noCancelReason: 'No reason recorded',
      reimbursementExplainer:
        'Reimbursement request: the host travelled to the property and the service was canceled on site. Approving posts the amount to the wallet of the host who travelled, as a detached payment, even if the job now belongs to another host.',
      requestDescription: 'Host report',
      chargeRealEstate: 'Charge the real estate agency',
      chargeRealEstateHint: 'The agency pays the full amount and the host gets the host rate; the host invoice goes to its CNPJ. Unchecked, Hauseful bears it and the host gets the full amount.',
      reimbursementHostPercent: 'Host rate',
      reimbursementHostPercentHint: 'Comes from the contract and can be changed. As in the contract, at 0% the host gets nothing.',
      reimbursementHostPercentInvalid: 'Enter a rate between 0 and 100',
      displacementValue: 'Displacement amount',
      approvedDisplacementValue: 'Approved displacement amount',
      displacementValueSuggested: 'Suggested by the host: {value}. The recalculation uses the amount entered here.',
      displacementValueHint: 'The host does not report an amount: enter the displacement amount. The agency pays it and the host gets the contract share.',
      notDeclared: 'Not provided',
      approvedReimbursementValue: 'Approved amount',
      reimbursementValue: 'Reimbursement amount',
      reimbursementContractShare: 'The contract displacement rate is {percent}%: when the agency is charged, it fills the host rate, which can be changed. Otherwise, the host gets the full amount.',
      reimbursementContractNoShare: 'The contract passes no displacement on to the host (0%): when the agency is charged, the host gets nothing unless the host rate is changed. Otherwise, the full amount.',
      reimbursementContractShareUnknown: 'The contract displacement rate could not be read. When the agency is charged, enter the host rate.',
      reimbursementPreviewCharging: 'The agency pays {value} and the host gets {hostValue}.',
      reimbursementPreviewFull: 'The host gets {value} and Hauseful bears it.',
      reimbursementHostReceived: 'Paid to the host',
      confirmReimbursement: 'Approve the reimbursement? The amount is posted to the host wallet.',
      confirmReimbursementWithValue:
        'Approve the {value} reimbursement? The amount is posted to the host wallet and Hauseful bears it.',
      confirmReimbursementCharging:
        'Approve the {value} reimbursement? The agency pays {value} and the host gets {hostValue}.',
    },

    messages: {
      reverse: 'Adjustment reversed',
      contest: 'Contest registered',
      approve: 'Recalculation applied',
      approveReimbursement: 'Reimbursement approved and posted to the host wallet.',
      refuse: 'Request refused',
    },
  },
}

export default enDivergence
